// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BankingDetailsTapCopyNumberEvent
 */
export var BankingDetailsTapCopyNumber = function (_a) {
    var type = _a.type;
    return ({
        name: "BankingDetails Tap CopyNumber",
        parameters: {
            cdf_entity: "BankingDetails",
            cdf_action: "Tap",
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see BankingDetailsTapHelpEvent
 */
export var BankingDetailsTapHelp = function () { return ({
    name: "BankingDetails Tap Help",
    parameters: {
        cdf_entity: "BankingDetails",
        cdf_action: "Tap",
    }
}); };
/**
 * @see BankingDetailsTapDirectDepositSetupEvent
 */
export var BankingDetailsTapDirectDepositSetup = function () { return ({
    name: "BankingDetails Tap DirectDepositSetup",
    parameters: {
        cdf_entity: "BankingDetails",
        cdf_action: "Tap",
    }
}); };
/**
 * @see BankingDetailsViewViewEvent
 */
export var BankingDetailsViewView = function () { return ({
    name: "BankingDetails View View",
    parameters: {
        cdf_entity: "BankingDetails",
        cdf_action: "View",
    }
}); };
